module.exports = __webpack_public_path__ + "img/NIM.984923b7.svg";